export enum FilterType {
  DeliveryNote,
}
